import App from './App.svelte';
import { sto_cliente_web } from './store'

let params = (new URL(document.location)).searchParams;

sto_cliente_web.actualizar({
	client_id: params.get('client_id'),
	redirect_url: params.get('redirect_uri'),
	state: params.get('state'),
	response_type: params.get('response_type')
});


const app = new App({
	target: document.getElementById('app'),
});

export default app;